module.exports = __webpack_public_path__ + "img/laurel-gitlen-1.0301ab77.png";